import { AxiosResponse } from "axios";
import { END_POINT_KAKAO } from "constants/Api";
import { TAddress } from "types/TAddress";
import { getKakaoUrl } from "utils/Utils";
import { kakaoApi } from "./Instance";

export const getAddress = async (x: number, y: number) => {
  const response = await kakaoApi.get<AxiosResponse<TAddress>>(getKakaoUrl(END_POINT_KAKAO.ADDRESS).replace(':x', String(x)).replace(':y', String(y)));
  return response;
}